/**
 * 获取数据字典
 */
import $axios from "@/service/httpServer";

export const getDataDictionary = name => $axios.get('/uc/sys/app/list', {code: name}) // 获取数据字典
export const getOrganizationTypeList = (orgId) => $axios.get('/uc/sys/app/getOrgTags', {orgId: orgId})
export const getOrganizationLevelList = () => $axios.get('/uc/sys/app/list', {code: 'ZZXZ'})


// 数据字典管理页面
export const getDictionaryList = p => $axios.get('/uc/sys/app/list', p)
export const getDictionaryTree = p => $axios.get('/uc/sys/app/list', p)
export const delDictionary = p => $axios.delete('/basic/dictparams/remove/' + p)
export const updateDictionary = p => $axios.post('/basic/dictparams/update', p)
export const addDictionary = p => $axios.post('/basic/dictparams/save', p)
// 字典分页查看
export const getDictionaryPage = p => $axios.get('/basic/dictparams/page', p)


